import { getRandomElementFromArray } from './array';

const DIGITS = '0123456789' as const;
const LETTERS = 'abcdefghijklmnopqrstuvwxyz' as const;

export function getStringInCamelCase(str: string) {
    return str.replace(/[-_]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''));
}

export function getStringInSnakeCase(str: string) {
    return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

export function getPlainTextFromHtml(html?: string | null) {
    if (!html) {
        return '';
    }

    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}

export function getRandomChars(length = 16, options: { onlyLetters?: boolean; onlyDigits?: boolean } = {}) {
    const { onlyLetters = false, onlyDigits = false } = options;

    const selectableChars: Array<string> = [];

    if (onlyLetters && onlyDigits) {
        throw new Error('Only one option can be true!');
    } else if (onlyLetters) {
        selectableChars.push(...LETTERS);
    } else if (onlyDigits) {
        selectableChars.push(...DIGITS);
    } else {
        selectableChars.push(...LETTERS, ...DIGITS);
    }

    const selectedChars = Array.from({ length }, () => getRandomElementFromArray(selectableChars));

    return selectedChars.join('');
}

export function generateUniqueId() {
    const timeId = new Date().getTime().toString(36);
    const randomChars = getRandomChars();
    const microTimeId = performance.now().toString(36).replace('.', '').padStart(8, '0').slice(0, 8);

    return `${timeId}-${randomChars}-${microTimeId}`;
}
